import React from "react";
import styled from "styled-components";
import { ScrollbarStyles } from "@themes/ScrollbarStyles";
import CalendarSidebar from "../../../calendar/components/CalendarSidebar";

const CalendarWeekViewContainer = styled.div<{ isVisible: boolean }>`
    display: ${(props) => (props.isVisible ? "block" : "none")};
    height: 100%;
    width: 100%;
    overflow-y: hidden;
    overflow-anchor: none;
    background: ${(props) => props.theme.backgroundSecondary};
    ${ScrollbarStyles};
`;

const StyledCalendar = styled(CalendarSidebar)`
    width: 100%;
    border-radius: unset;
    min-width: unset;
    background: ${(props) => props.theme.backgroundSecondary};

    .rbc-calendar[style] {
        width: inherit !important;
    }

    .rbc-time-content > * + * > *,
    .rbc-time-header-content,
    .rbc-time-header {
        border-right: 1px solid ${(props) => props.theme.borderPrimary} !important;
    }

    .rbc-time-header {
        border: none !important;

        * > {
            border: none !important;
        }
    }

    .rbc-day-bg + .rbc-day-bg,
    .rbc-header + .rbc-header {
        border-left: 1px solid ${(props) => props.theme.borderPrimary} !important;
    }

    .rbc-header {
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .calendar-all-day-event-gutter {
        padding-top: 45px;

        .calendar-all-day-event-gutter-text {
            white-space: nowrap;
        }
    }
`;

interface CalendarWeekViewProps {
    isVisible: boolean;
    className?: string;
}
export default function CalendarWeekView(props: CalendarWeekViewProps) {
    return (
        <CalendarWeekViewContainer isVisible={props.isVisible} className={`calendar-week-view ${props.className}`}>
            <StyledCalendar show={props.isVisible} amplitudeEventSource={"calendar-view"} calendarView={"week"} />
        </CalendarWeekViewContainer>
    );
}
